import type { ReactNode } from 'react';
import { Button } from '~/components/ui/button';

interface ModalActionsProps {
  onDismiss: () => void;
  /** "Close" for read-only content, "Cancel" when the primary action would change something, "Back" mid-wizard. */
  dismissLabel?: string;
  dismissDisabled?: boolean;
  dismissTestId?: string;
  /** The primary (and any other) actions, drawn after the dismiss button. */
  children?: ReactNode;
}

/** Footer row for modals that are not a form: outline dismiss, then the primary actions (DESIGN.md §10.2). */
export function ModalActions({
  onDismiss,
  dismissLabel = 'Close',
  dismissDisabled,
  dismissTestId,
  children,
}: ModalActionsProps) {
  return (
    <div className="flex items-center justify-end gap-3">
      <Button
        variant="outline"
        size="sm"
        onClick={onDismiss}
        disabled={dismissDisabled}
        testId={dismissTestId}
      >
        {dismissLabel}
      </Button>
      {children}
    </div>
  );
}
